const tools = [
  "GIT",
  "AWS",
  "GCP",
  "KUBERNETES",
  "REDIS",
  "GRPC",
  "METABASE",
];

export default tools;
